import { withFormikFields } from 'utils/withFormikFields'
import {
  Select as RawSelect,
  InputField as RawInputField,
  DatePicker as RawDatePicker,
  DateTimePicker as RawDateTimePicker,
  Checkbox as RawCheckbox,
  Radio as RawRadio,
} from 'components/inputs'

export const Select = withFormikFields(RawSelect)
export const InputField = withFormikFields(RawInputField)
export const DatePicker = withFormikFields(RawDatePicker)
export const DateTimePicker = withFormikFields(RawDateTimePicker)
export const Checkbox = withFormikFields(RawCheckbox)
export const Radio = withFormikFields(RawRadio)

export * from './Button'
export * from './Counter'
export * from './Footer'
export * from './Header'
export * from './Link'
export * from './LinkButton'
export * from './RadioGroupField'
export * from './Wizard'
export * from './Modal'
export * from './Station'
export * from './VehicleCount'
